// T2 · Tuile SUIVANTE (condensée) — une entrée par ligne de pizza, note libre
// rattachée à SA pizza (NotePizza, 6b.1), statut de délai attaché à la commande
// (§2, LOT 7b). Statique, jamais de téléphone.
import { parseNotes } from '@/lib/notes-convention';
import { NOTE_MAX_SUIVANTE, NotePizza } from '@/screens/shared/NotePizza';
import { StatutDelai } from '@/screens/shared/StatutDelai';
import type { StatutDelai as StatutDelaiMoteur } from '@/lib/heure-capacite';
import type { TuileT2 } from '@/hooks/useT2File';

interface Props {
  tuile: TuileT2;
  nomParId: Map<number, string>;
  rang: number;
  delai: StatutDelaiMoteur | undefined;
}

export function TuileSuivante({ tuile, nomParId, rang, delai }: Props) {
  const { lignes, trainN } = tuile;
  return (
    <div
      data-testid="tuile-suivante"
      className="relative flex flex-col gap-1 bg-card/60 p-4"
    >
      <span className="flex flex-wrap items-baseline gap-x-3">
        <span className="font-jost text-sm tracking-wide text-muted-foreground uppercase">
          Suivante {rang}
        </span>
        <StatutDelai delai={delai} className="text-sm" />
      </span>
      <span className="flex flex-wrap items-baseline gap-x-2 gap-y-1 font-jost text-2xl font-medium">
        {lignes.map((l, i) => (
          <span key={l.id} className="flex items-baseline gap-x-2">
            {i > 0 && <span aria-hidden="true">·</span>}
            <span>
              {l.qty}× {nomParId.get(l.pizzaId) ?? `#${l.pizzaId}`}
            </span>
            <NotePizza
              texte={parseNotes(l.notes_libres ?? '').texte}
              max={NOTE_MAX_SUIVANTE}
              className="text-lg font-normal"
            />
          </span>
        ))}
      </span>
      {trainN > 1 && (
        <span
          aria-label={`Train de ${trainN} commandes`}
          className="absolute top-4 right-4 rounded-full bg-ardoise px-3 py-0.5 font-mono text-creme"
        >
          ×{trainN}
        </span>
      )}
    </div>
  );
}
